<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span
          ><em name="Exhibition"></em><span>/</span>
          <a href="javascript:history.back()">新聞稿</a><span>/</span>修改新聞稿
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <div class="container">
            <h1>修改新聞稿</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="EditVideo">
              <p class="formTitle">官網狀態 <span class="red">*</span></p>
              <label
                ><input
                  type="radio"
                  name="Archived"
                  value="0"
                  v-model="NewsData.Archived"
                  class="largeItem true"
                />
                顯示</label
              >
              <label
                ><input
                  type="radio"
                  name="Archived"
                  value="1"
                  v-model="NewsData.Archived"
                  class="largeItem false ml-2"
                />
                隱藏</label
              >
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">新聞主旨 <span class="red">*</span></p>

              <div v-if="LocalExh">
                <div class="langTip">
                  <input
                    type="text"
                    name="NewsTopic"
                    class="maxText textStyle"
                    maxlength="50"
                    v-model="NewsData.NewsTopic"
                    placeholder="限制為50字"
                  />
                  <span>中</span>
                </div>
                <div id="error2"></div>
              </div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  v-model="NewsData.eNewsTopic"
                  maxlength="100"
                  placeholder="限制為100字元"
                />
                <span>EN</span>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">相關連結</p>
              <div v-if="LocalExh">
                <div class="langTip">
                  <input
                    type="text"
                    name="NewsTopic"
                    class="maxText textStyle"
                    maxlength="200"
                    v-model="NewsData.NewsUrl"
                  />
                  <span>中 </span>
                </div>
              </div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  maxlength="200"
                  v-model="NewsData.eNewsUrl"
                />
                <span>EN</span>
              </div>
              <p class="my-3">&nbsp;</p>
              <div v-if="LocalExh">
                <p class="formTitle">
                  新聞內容 (中) <span class="red">*</span>
                </p>

                <ckeditor
                  v-model="NewsData.NewsContent"
                  :config="editorConfig"
                ></ckeditor>

                <!-- <textarea name="NewsContent" class="maxText textStyle ckeditor" v-model="NewsData.NewsContent"></textarea> -->
                <div id="error"></div>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">
                新聞內容 (English) <span class="red" v-if="!LocalExh">*</span>
              </p>
              <!-- <textarea
                name="eNewsContent"
                class="maxText textStyle ckeditor"
                v-model="NewsData.eNewsContent"
              ></textarea> -->

              <ckeditor
                v-model="NewsData.eNewsContent"
                :config="editorConfig"
              ></ckeditor>
              <p class="my-3">&nbsp;</p>

              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backNewsPage">
                  返回
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "新聞稿 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      LocalExh: true,

      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      NewsId: "",
      NewsData: [],
      lang: "tw",
    };
  },

  methods: {
    // EditVideo() {
    //   const vm = this;

    //   if (vm.LocalExh) {
    //     if (!vm.NewsData.NewsTopic || !vm.NewsData.NewsContent) {
    //       $("html,body").animate({ scrollTop: 0 }, "slow");

    //       alert("輸入欄位不完整，請重新檢查！");

    //       if (!vm.NewsData.NewsTopic) {
    //         $("#error2").html(
    //           "<span class='errorTextArea'>請填寫此欄位</span>"
    //         );
    //         $("#error").html("<p class='errorTextArea'></p>");

    //         if (!vm.NewsData.NewsContent) {
    //           $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //         }
    //       } else {
    //         $("#error2").html("<span class='errorTextArea'></span>");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       }
    //     } else {
    //       if (!vm.NewsData.NewsContent) {
    //         alert("輸入欄位不完整，請重新檢查！");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       } else {
    //         const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`;

    //         const info = {
    //           NewsTopic: vm.NewsData.NewsTopic,
    //           eNewsTopic: vm.NewsData.eNewsTopic,
    //           NewsUrl: vm.NewsData.NewsUrl,
    //           eNewsUrl: vm.NewsData.eNewsUrl,
    //           NewsContent: vm.NewsData.NewsContent,
    //           eNewsContent: vm.NewsData.eNewsContent,
    //           Archived: vm.NewsData.Archived,
    //           CSRF: vm.CSRF_Token,
    //         };

    //         // console.log(info)

    //         axios.post(url, info).then(function (response) {
    //           if (response.data.Code == 200) {
    //             alert("您已成功修改新聞稿內容！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (
    //             response.data.Code == 251 ||
    //             response.data.Code == 500
    //           ) {
    //             alert("系統忙碌，請稍後再試！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (response.data.Code == 252) {
    //             document.location.href = `https://www.chanchao.com.tw/`;
    //           }
    //         });
    //       }
    //     }
    //   } else {
    //     if (!vm.NewsData.eNewsTopic || !vm.NewsData.eNewsContent) {
    //       $("html,body").animate({ scrollTop: 0 }, "slow");

    //       alert("輸入欄位不完整，請重新檢查！");

    //       if (!vm.NewsData.eNewsTopic) {
    //         $("#error2").html(
    //           "<span class='errorTextArea'>請填寫此欄位</span>"
    //         );
    //         $("#error").html("<p class='errorTextArea'></p>");

    //         if (!vm.NewsData.eNewsContent) {
    //           $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //         }
    //       } else {
    //         $("#error2").html("<span class='errorTextArea'></span>");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       }
    //     } else {
    //       if (!vm.NewsData.eNewsContent) {
    //         alert("輸入欄位不完整，請重新檢查！");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       } else {
    //         const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`;

    //         const info = {
    //           NewsTopic: vm.NewsData.NewsTopic,
    //           eNewsTopic: vm.NewsData.eNewsTopic,
    //           NewsUrl: vm.NewsData.NewsUrl,
    //           eNewsUrl: vm.NewsData.eNewsUrl,
    //           NewsContent: vm.NewsData.NewsContent,
    //           eNewsContent: vm.NewsData.eNewsContent,
    //           Archived: vm.NewsData.Archived,
    //           CSRF: vm.CSRF_Token,
    //         };

    //         // console.log(info)

    //         axios.post(url, info).then(function (response) {
    //           if (response.data.Code == 200) {
    //             alert("您已成功修改新聞稿內容！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (
    //             response.data.Code == 251 ||
    //             response.data.Code == 500
    //           ) {
    //             alert("系統忙碌，請稍後再試！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (response.data.Code == 252) {
    //             document.location.href = `https://www.chanchao.com.tw/`;
    //           }
    //         });
    //       }
    //     }
    //   }
    // },

    EditVideo() {
      const vm = this;

      // 根據 LocalExh 決定要檢查哪組欄位
      const topicField = vm.LocalExh ? "NewsTopic" : "eNewsTopic";
      const contentField = vm.LocalExh ? "NewsContent" : "eNewsContent";

      const topicValue = vm.NewsData[topicField];
      const contentValue = vm.NewsData[contentField];

      // 驗證欄位是否完整
      if (!topicValue || !contentValue) {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        alert("輸入欄位不完整，請重新檢查！");

        $("#error2").html(
          !topicValue ? "<span class='errorTextArea'>請填寫此欄位</span>" : ""
        );
        $("#error").html(
          !contentValue ? "<p class='errorTextArea'>請填寫此欄位</p>" : ""
        );

        return;
      }

      // API 送出
      const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`;
      const info = {
        NewsTopic: vm.NewsData.NewsTopic,
        eNewsTopic: vm.NewsData.eNewsTopic,
        NewsUrl: vm.NewsData.NewsUrl,
        eNewsUrl: vm.NewsData.eNewsUrl,
        NewsContent: vm.NewsData.NewsContent,
        eNewsContent: vm.NewsData.eNewsContent,
        Archived: vm.NewsData.Archived,
        CSRF: vm.CSRF_Token,
      };

      axios.post(url, info).then((response) => {
        const code = response.data.Code;
        if (code === 200) {
          alert("您已成功修改新聞稿內容！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
        } else if (code === 251 || code === 500) {
          alert("系統忙碌，請稍後再試！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
        } else if (code === 252) {
          document.location.href = `https://www.chanchao.com.tw/`;
        }
      });
    },

    EditEnVideo() {
      const vm = this;

      if (!vm.NewsData.eNewsTopic || !vm.eNewsContent) {
        $("html,body").animate({ scrollTop: 0 }, "slow");

        alert("There are incomplete fields, please check again.");

        if (!vm.NewsData.eNewsTopic) {
          $("#error2").html(
            "<span class='errorTextArea'>This field is required.</span>"
          );
          $("#error").html("<p class='errorTextArea'></p>");

          if (!vm.eNewsContent) {
            $("#error").html(
              "<p class='errorTextArea'>This field is required.</p>"
            );
          }
        } else {
          $("#error2").html("<span class='errorTextArea'></span>");
          $("#error").html(
            "<p class='errorTextArea'>This field is required.</p>"
          );
        }
      } else {
        if (!vm.eNewsContent) {
          alert("There are incomplete fields, please check again.");
          $("#error").html(
            "<p class='errorTextArea'>This field is required.</p>"
          );
        } else {
          const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`;

          const info = {
            NewsTopic: vm.NewsData.NewsTopic,
            eNewsTopic: vm.NewsData.eNewsTopic,
            NewsUrl: vm.NewsData.NewsUrl,
            eNewsUrl: vm.NewsData.eNewsUrl,
            NewsContent: vm.NewsData.NewsContent,
            eNewsContent: vm.NewsData.eNewsContent,
            Archived: vm.NewsData.Archived,
            CSRF: vm.CSRF_Token,
          };

          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("Successfully changed your news information!");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
            }
          });
        }
      }
    },

    backNewsPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    //語系會自動抓html lang tag

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
        //   alert(vm.CSRF_Token)
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    //取出url裡的NewsId
    vm.NewsId = currentUrl.split("id=")[1];

    //取得特定新聞稿
    let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`;
    axios
      .get(url)
      .then(function (response) {
        if (response.data.Data) {
          vm.NewsData = response.data.Data;
        } else {
          alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
        }
      })
      .catch((err) => {
        alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        }
      });
  },
};
</script>

<style lang="scss"></style>
